export class PageHeader {
  public ShowAccountInfo: boolean = true;
  public IsHeadline: boolean = false;
  public Message: string = '';
  public RedirectURL: string = '';
  public ButtonLabel: string = '';
  public ButtonAriaLabel: string = '';
}
